import React, { useRef } from "react";

// React DnD
import { useDrop } from "react-dnd";
import { ItemTypes } from "./DraggableVariable";

// Constants
import { variableNameRegex } from "../MessageSettings";

// Components
import { FormikTextField } from "Common/Components";

const MAX_MESSAGE_LENGTH_EN = 400;
const MAX_MESSAGE_LENGTH_FR = 600;

const FormikDraggableTextField = ({ formik, field, language, formikValue }) => {
  const inputRef = useRef(null);
  const value = formik.values[formikValue]?.[field.id]?.[language] || "";

  const visibleText = value.replace(variableNameRegex, "");
  const charsLeft =
    language === "en"
      ? MAX_MESSAGE_LENGTH_EN - visibleText.length
      : MAX_MESSAGE_LENGTH_FR - visibleText.length;

  const errorText =
    formik.touched[formikValue]?.[field.id]?.[language] &&
    formik.errors[formikValue]?.[field.id]?.[language];

  // DnD drop logic
  const [, drop] = useDrop(() => ({
    accept: ItemTypes.VARIABLE,
    drop: (item, _) => {
      const variableText = `{{${item.name}}}`;
      const textarea = inputRef.current;

      if (textarea) {
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        // Read the actual current value from the textarea
        const currentValue = textarea.value;

        const newValue =
          currentValue.substring(0, start) +
          variableText +
          currentValue.substring(end);

        formik.setFieldValue(
          `${formikValue}.${field.id}.${language}`,
          newValue
        );

        // Restore focus and move cursor after inserted text
        setTimeout(() => {
          textarea.focus();
          textarea.selectionStart = textarea.selectionEnd =
            start + variableText.length;
        }, 0);
      }
    },
  }));
  const combinedRef = (node) => {
    inputRef.current = node;
    drop(node);
  };

  return (
    <FormikTextField
      formik={formik}
      field={field}
      name={`${formikValue}.${field.id}.${language}`}
      inputRef={combinedRef}
      helperText={
        errorText
          ? `${errorText} (${charsLeft} characters left)`
          : `${charsLeft} characters left`
      }
    />
  );
};

export default FormikDraggableTextField;
